"use client";

import { Check, Copy } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { copyTextWithToast } from "@/lib/client-clipboard";

/** Copies the user's message; shown beside its time and author. */
export function CopyUserMessageButton(props: { text: string }) {
  const [copied, setCopied] = useState(false);

  return (
    <Button
      type="button"
      size="icon-xs"
      variant="ghost"
      aria-label={copied ? "Copied user message" : "Copy user message"}
      className="text-muted-foreground hover:text-foreground"
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        void copyTextWithToast(props.text, {
          successTitle: "Message copied",
          errorTitle: "Failed to copy message",
        }).then((copiedText) => {
          if (!copiedText) return;
          setCopied(true);
          window.setTimeout(() => setCopied(false), 2000);
        });
      }}
    >
      {copied ? <Check className="size-3" /> : <Copy className="size-3" />}
    </Button>
  );
}
